import { render, staticRenderFns } from "./LahanDetail.new.vue?vue&type=template&id=653ac12f"
import script from "./LahanDetail.new.vue?vue&type=script&lang=js"
export * from "./LahanDetail.new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports